import { render, staticRenderFns } from "./DetailsContactInfo.vue?vue&type=template&id=64b03b14"
import script from "./DetailsContactInfo.vue?vue&type=script&lang=ts"
export * from "./DetailsContactInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports